import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./index";

// استخدم دول دايماً بدل useDispatch و useSelector العادية
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T): T =>
  useSelector(selector);